import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Center } from 'src/app/interfaces/center';
import { CenterService } from 'src/app/services/center.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-add-edit-center',
  templateUrl: './add-edit-center.component.html',
  styleUrls: ['./add-edit-center.component.css']
})
export class AddEditCenterComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  id: number;
  operacion: string = 'Agregar ';

  constructor(private fb: FormBuilder,
    private _centerService: CenterService,
    private router: Router,
    private toastr: ToastrService,
    private aRouter: ActivatedRoute) {
    this.form = this.fb.group({
      name: ['', Validators.required],
    })
    this.id = Number(aRouter.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {

    if (this.id != 0) {
      // Es editar
      this.operacion = 'Editar ';
      this.getCenter(this.id);
    }
  }

  getCenter(id: number) {
    this.loading = true;
    this._centerService.getCenter(id).subscribe((data: Center) => {
      this.loading = false;
      this.form.setValue({
        name: data.name
      })
    })
  }

  addCenter() {
    /*  console.log(this.form.value.name);
     console.log(this.form.get('name')?.value); */

    const center: Center = {
      name: this.form.value.name
    }
    this.loading = true;

    if (this.id !== 0) {
      // Es editar 
      console.log("Editado: "+ center);
      center.id = this.id;
      this._centerService.updateCenter(this.id, center).subscribe(() => {
        this.toastr.info(`El centero ${center.name} fue actualizado con exito`, 'Centero actualizado');
        this.loading = false;
        this.router.navigate(['/center']);
      })

    } else {
      // Es agregagar
      console.log("Agregado: "+ center);
      this._centerService.saveCenter(center).subscribe(() => {
        this.toastr.success(`El centero ${center.name} fue registrado con exito`, 'Centero registrado');
        this.loading = false;
        this.router.navigate(['/center']);
      })
    }
  }
}
